module.exports = __webpack_public_path__ + "img/cisco-webex.23c89e5e.png";